<template>
    <form @submit.prevent="handleSubmit" autocomplete="off">
        <div class="form-group">
            <label for="name" class="col-form-label">Nombre</label>
            <input
                class="form-control"
                id="name"
                name='name'
                type="text"
                :class="{ 'is-invalid' : errors.name }"
                v-model="form.name"
            >
            <invalid-feedback :error="errors.name"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="slug" class="col-form-label">Slug</label>
            <input
                aria-describedby="slug-help"
                class="form-control"
                id="slug"
                slug='slug'
                type="text"
                :class="{ 'is-invalid' : errors.slug }"
                v-model="form.slug"
            >
            <small id="slug-help" class="form-text text-muted">Sí se modifica el slug, el deploy podría dejar de funcionar.</small>
            <invalid-feedback :error="errors.slug"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="url_admin" class="col-form-label">URL Administración</label>
            <input
                class="form-control"
                id="url_admin"
                url_admin='url_admin'
                type="url"
                :class="{ 'is-invalid' : errors.url_admin }"
                v-model="form.url_admin"
            >
            <invalid-feedback :error="errors.url_admin"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="url_home" class="col-form-label">URL Sitio principal</label>
            <input
                aria-describedby="url-home-help"
                class="form-control"
                id="url_home"
                url_home='url_home'
                type="url"
                :class="{ 'is-invalid' : errors.url_home }"
                v-model="form.url_home"
            >
            <small id="url-home-help" class="form-text text-muted">Puede quedar vacío.</small>
            <invalid-feedback :error="errors.url_home"></invalid-feedback>
        </div>
        <div class="form-group" v-show="emails.includes(email)">
            <label for="git_branch" class="col-form-label">GIT Branch (para deploy)</label>
            <input
                aria-describedby="url-git-branch-help"
                class="form-control"
                id="git_branch"
                git_branch='git_branch'
                type="text"
                :class="{ 'is-invalid' : errors.git_branch }"
                v-model="form.git_branch"
            >
            <small id="url-git-branch-help" class="form-text text-muted">Branch para ejecutar deploy. Puede quedar vacío.</small>
            <invalid-feedback :error="errors.git_branch"></invalid-feedback>
        </div>
        <div class="form-group">
            <label for="logo" class="col-form-label">Logo</label>
            <input
                accept="image/*"
                class="form-control"
                id="logo"
                type="file"
                :class="{ 'is-invalid' : errors.logo }"
                @change="handleImage($event)"
                ref="logo"
            >
            <invalid-feedback :error="errors.logo"></invalid-feedback>
            <img :src="client.logo_url" v-show="client.logo" class="img-fluid img-thumbnail mt-2 w-25 h-25">
        </div>
        <button type="submit" class="btn btn-primary btn-block">Editar</button>
    </form>
</template>

<script>
    import InvalidFeedback from '@/components/InvalidFeedback'

    export default {
        props: {
            client: Object,
            emails: Array,
            email: String
        },
        data() {
            return {
                errors: [],
                form: {
                    name: this.client.name,
                    git_branch: this.client.git_branch,
                    slug: this.client.slug,
                    url_admin: this.client.url_admin,
                    url_home: this.client.url_home
                },
                logo: ''
            }
        },
        methods: {
            handleImage(evt) {
                this.logo = _.head(evt.target.files)
            },
            handleSubmit() {
                let formData = new FormData()
                formData.append('git_branch', this.form.git_branch || '')
                formData.append('logo', this.logo)
                formData.append('name', this.form.name)
                formData.append('slug', this.form.slug)
                formData.append('url_admin', this.form.url_admin)
                formData.append('url_home', this.form.url_home || '')
                formData.append('_method', 'PUT')

                axios.post(this.route('admin.clients.update', this.client), formData)
                .then(response => {
                    this.$refs.logo.value = null
                    window.location.href = this.route('home')
                }).catch(error => {
                    const { status } = error.response
                    if (status === 422) {
                        this.errors = error.response.data.errors
                    }
                })
            }
        },
        components: {
            'invalid-feedback': InvalidFeedback
        }
    }
</script>